/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Settings_Group_BillingInputs */

const cs_nav_settings_group_billing = /** @type {(inputs: Nav_Settings_Group_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fakturace`)
};

const en_nav_settings_group_billing = /** @type {(inputs: Nav_Settings_Group_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Nav_Settings_Group_BillingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_settings_group_billing = /** @type {((inputs?: Nav_Settings_Group_BillingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Settings_Group_BillingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_settings_group_billing(inputs)
	return cs_nav_settings_group_billing(inputs)
});